import '../sass/main.sass';


import './use-cases/scroll-reveal';

import _ from "lodash";
import LazyLoad from "vanilla-lazyload";

import './use-cases/swipers';
// import './use-cases/fslightbox';

import Loader from './modules/loader';
import Menu from './modules/menu';
import CookieConsent from './modules/cookie-consent';
import Switcher from './modules/switcher';


import './methods/fix-iframe-height';
import './methods/play-video';
import './methods/scroll-top';

//** Lazyload */
new LazyLoad({
  elements_selector: ".lazy"
});

//** Loader **/
new Loader(); 

//** Menu **/
new Menu({
  button: '.js-toggle-menu',
  elToMove: '.page-body',
  menuToMove: '.page-menu',
  pageHeader: '.page-header',
  menuWrapper: '.menu',
  classToAdd: 'is-moved',
  elToAnimate: '.menu > .menu-item',
  animateClass: 'is-visible',
  delay : 100,
  headerHeight: 100,
});

//** Cookies **/
new CookieConsent({
  cookieWrapper: '.js-cookie-consent',
  cookieCancel: '.js-close-cookie',
  expirationDays: 30
});

//**  Switcher **/
new Switcher({
  switcherButton: '.js-offer-switcher',
  dataEl: 'data-id',
  switchingItem: '.js-offer-switcher-item',
  activeClass: 'is-active',
  toggle: true,
  });